(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aua-custom-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  const videos = new Set();
  let activeMediaClose;
  function initialize(root) {
    if (instances.has(root)) return;
    // Add the rating to the main product title (which belongs to a different Shopify section).
    // No extra network request or product data lookup is required.
    let titleRatingBadge = null;
    let restoreTitleLayout = null;
    const ratingSource = root.querySelector('[data-aua-title-rating-source]');
    if (ratingSource) {
      const customSelector = root.dataset.auaTitleSelector?.trim();
      const titleSelectors = [
        customSelector,
        'main .product__title h1',
        'main h1.product__title',
        'main .product-single__title',
        'main .product-info__title h1',
        'main .product__info-container h1',
        'main .product-info h1',
        'main .product-block--header h1',
        'main [data-product-title] h1',
        'main h1[data-product-title]',
        'main h1[itemprop="name"]',
        'main .product-main h1',
        'main .product-form__title h1',
        // Cross-theme fallback: the page product's main heading is normally an h1.
        'main h1',
        '.product__title h1',
        '[data-product-title]',
        'h1'
      ].filter(Boolean);
      let productTitle = null;
      const expectedTitle = (root.dataset.auaProductTitle || '').trim().toLocaleLowerCase();
      // Prefer an exact product heading before selector fallbacks; useful in custom themes.
      if (expectedTitle) {
        productTitle = [...document.querySelectorAll('main h1, h1, [data-product-title]')]
          .find(node => !root.contains(node) && node.getClientRects().length > 0 &&
            node.textContent.trim().toLocaleLowerCase() === expectedTitle) || null;
      }
      for (const selector of (productTitle ? [] : titleSelectors)) {
        try {
          const candidates = [...document.querySelectorAll(selector)];
          // Skip review headings and hidden headings; product titles reside outside this section.
          productTitle = candidates.find(node => !root.contains(node) &&
            !node.closest('header, footer, .site-header, .mobile-header, [hidden]') &&
            node.getClientRects().length > 0) || null;
        } catch (error) {
          // Ignore unsupported custom selectors; continue with compatible defaults.
        }
        if (productTitle) break;
      }
      if (productTitle) {
        const titleContainer = productTitle.closest('.product__title, .product-info__title') || productTitle;
        titleRatingBadge = ratingSource.querySelector('a')?.cloneNode(true) || null;
        // The source badge sits in a hidden template, so check only already-mounted badges.
        if (titleRatingBadge && !document.querySelector('[data-aua-title-rating-mounted]')) {
          titleRatingBadge.setAttribute('data-aua-title-rating-mounted', root.id);
          const parent = titleContainer.parentElement;
          const parentStyle = parent ? getComputedStyle(parent) : null;
          const parentDisplay = parentStyle?.display || '';
          const horizontalFlex = parentDisplay.includes('flex') && parentStyle.flexDirection.startsWith('row');
          const gridParent = parentDisplay.includes('grid');
          if (horizontalFlex || gridParent) {
            // Adjacent children of a row/grid would display side-by-side. Keep the
            // existing heading markup intact inside a small vertical wrapper.
            const marker = document.createComment('AUA product title original position');
            const stack = document.createElement('div');
            stack.className = 'aua-product-title-rating-stack';
            titleContainer.before(marker);
            marker.after(stack);
            stack.append(titleContainer, titleRatingBadge);
            restoreTitleLayout = () => {
              if (marker.isConnected) marker.replaceWith(titleContainer);
              else if (stack.isConnected) stack.replaceWith(titleContainer);
              stack.remove();
            };
          } else {
            // Normal block flow reliably puts this separate rating row below the title.
            titleContainer.insertAdjacentElement('afterend', titleRatingBadge);
          }
        } else {
          titleRatingBadge = null;
        }
      }
    }
    const controller = new AbortController();
    const signal = controller.signal;
    const listen = (node, name, callback, options = {}) => node?.addEventListener(name, callback, {...options, signal});
    const dialog = root.querySelector('.aua-media-dialog');
    const stage = dialog.querySelector('[data-media-stage]');
    const mediaStatus = dialog.querySelector('[data-media-status]');
    let opener;
    let mediaOpen = false;
    let scrollStyles;
    let mediaEvents;
    const closeMedia = () => {
      if (!mediaOpen) return;
      mediaOpen = false;
      mediaEvents?.abort();
      stage.querySelectorAll('video').forEach(video => {
        video.pause();
        videos.delete(video);
        video.removeAttribute('src');
        video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
        video.load();
      });
      stage.replaceChildren();
      if (dialog.open) dialog.close();
      document.documentElement.style.overflow = scrollStyles.html;
      document.body.style.overflow = scrollStyles.body;
      document.body.style.paddingRight = scrollStyles.padding;
      if (activeMediaClose === closeMedia) activeMediaClose = undefined;
      if (opener?.isConnected) opener.focus({preventScroll:true});
    };
    listen(root, 'click', event => {
      const firstReviewLink = event.target.closest('[data-aua-first-review]');
      if (firstReviewLink && root.contains(firstReviewLink)) {
        const reviewForm = root.querySelector('.aua-write-review');
        if (reviewForm) reviewForm.open = true;
      }
    });
    listen(root, 'click', event => {
      const trigger = event.target.closest('[data-aua-media]');
      if (!trigger || !root.contains(trigger) || typeof dialog.showModal !== 'function') return;
      const template = document.getElementById(trigger.dataset.auaMedia);
      if (!template?.content) return;
      event.preventDefault();
      activeMediaClose?.();
      opener = trigger;
      stage.replaceChildren(template.content.cloneNode(true));
      dialog.querySelector('[data-media-heading]').textContent = trigger.dataset.mediaTitle;
      dialog.querySelector('[data-media-original]').href = trigger.href;
      mediaStatus.textContent = mediaStatus.dataset.loading;
      scrollStyles = {html:document.documentElement.style.overflow,body:document.body.style.overflow,padding:document.body.style.paddingRight};
      const scrollbar = window.innerWidth - document.documentElement.clientWidth;
      const padding = parseFloat(getComputedStyle(document.body).paddingRight) || 0;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      if (scrollbar > 0) document.body.style.paddingRight = (padding + scrollbar) + 'px';
      mediaOpen = true;
      activeMediaClose = closeMedia;
      mediaEvents = new AbortController();
      const media = stage.querySelector('video, img');
      if (!media) { closeMedia(); return; }
      const loaded = () => { mediaStatus.textContent = ''; };
      media.addEventListener('error', () => { mediaStatus.textContent = mediaStatus.dataset.error; }, {signal:mediaEvents.signal});
      if (media.tagName === 'VIDEO') {
        videos.add(media);
        media.addEventListener('loadeddata', loaded, {signal:mediaEvents.signal});
        media.addEventListener('play', () => videos.forEach(other => { if (other !== media) other.pause(); }), {signal:mediaEvents.signal});
        
        mediaStatus.textContent = '';
      } else {
        media.addEventListener('load', loaded, {signal:mediaEvents.signal});
        if (media.complete) mediaStatus.textContent = media.naturalWidth ? '' : mediaStatus.dataset.error;
      }
    });
    listen(dialog.querySelector('[data-media-close]'), 'click', closeMedia);
    listen(dialog, 'cancel', event => { event.preventDefault(); closeMedia(); });
    listen(dialog, 'close', () => { if (!dialog.open) closeMedia(); });
    listen(dialog, 'click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeMedia();
    });
    const track = root.querySelector('.aua-reviews__track');
    const controls = root.querySelector('.aua-review-controls');
    let observer;
    let frame = 0;
    if (track && controls) {
      const prev = controls.querySelector('[data-prev]');
      const next = controls.querySelector('[data-next]');
      const all = controls.querySelector('[data-all]');
      const hint = root.querySelector('.aua-reviews__mobile-hint');
      const originalLabel = all.textContent;
      const update = () => {
        frame = 0;
        const expanded = root.classList.contains('aua-expanded');
        const overflow = track.scrollWidth > track.clientWidth + 2;
        const position = Math.abs(track.scrollLeft);
        controls.hidden = false;
        prev.hidden = next.hidden = expanded;
        prev.disabled = position <= 2;
        next.disabled = position + track.clientWidth >= track.scrollWidth - 2;
        if (hint) hint.hidden = expanded || !overflow;
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      const move = direction => {
        const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
        track.scrollBy({left: direction * rtl * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      listen(prev, 'click', () => move(-1));
      listen(next, 'click', () => move(1));
      listen(all, 'click', () => {
        const expanded = root.classList.toggle('aua-expanded');
        all.setAttribute('aria-expanded', String(expanded));
        all.textContent = expanded ? all.dataset.collapsed : originalLabel;
        track.scrollLeft = 0;
        update();
      });
      listen(track, 'scroll', schedule, {passive: true});
      if ('ResizeObserver' in window) {
        observer = new ResizeObserver(schedule);
        observer.observe(track);
      } else {
        listen(window, 'resize', schedule, {passive: true});
      }
      update();
    }
    const form = root.querySelector('.aua-whatsapp-form');
    if (form) {
      const phone = form.dataset.phone;
      const submit = form.querySelector('button[type="submit"]');
      submit.disabled = !/^[1-9]\d{6,14}$/.test(phone);
      listen(form, 'submit', event => {
        event.preventDefault();
        if (!form.reportValidity() || submit.disabled) return;
        const data = new FormData(form);
        const name = String(data.get('reviewer') || '').trim();
        const review = String(data.get('review') || '').trim();
        const rating = String(data.get('rating') || '');
        const status = form.querySelector('[data-status]');
        if (!name || review.length < 5 || !/^[1-5]$/.test(rating)) {
          status.textContent = form.dataset.validation;
          return;
        }
        const message = ['*AUA&CO | Customer Review*', '', '*Customer*', name, '', '*Product*', String(data.get('item') || '').trim() || form.dataset.product, '', '*Page link*', form.dataset.page, '', '*Rating*', rating + ' / 5', '', '*Review*', review].join('\n');
        const url = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(message);
        const fallback = document.createElement('a');
        fallback.href = url;
        fallback.target = '_blank';
        fallback.rel = 'noopener noreferrer';
        fallback.textContent = form.dataset.open;
        status.replaceChildren(document.createTextNode(form.dataset.sent + ' '), fallback);
        window.open(url, '_blank', 'noopener,noreferrer');
      });
    }
    instances.set(root, () => {
      titleRatingBadge?.remove();
      restoreTitleLayout?.();
      closeMedia();
      controller.abort();
      observer?.disconnect();
      if (frame) cancelAnimationFrame(frame);
      instances.delete(root);
    });
  }
  function roots(container) {
    return [...(container.matches?.('[data-aua-reviews]') ? [container] : []), ...container.querySelectorAll('[data-aua-reviews]')];
  }
  function scan(container) { roots(container).forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), {once:true});
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => roots(event.target).forEach(root => instances.get(root)?.()));
  document.addEventListener('visibilitychange', () => { if (document.hidden) videos.forEach(video => video.pause()); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aua-product-flow')) {
    customElements.define('aua-product-flow', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        if (this.dataset.enabled !== 'true' || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        if (this.motion.matches) return;
        const cards = [...this.querySelectorAll('[data-aua-product]')];
        const mobile = matchMedia('(max-width: 767px)').matches;
        this.animations = new Set();
        this.observer = new IntersectionObserver(entries => {
          const visible = entries.filter(entry => entry.isIntersecting);
          visible.sort((a, b) => cards.indexOf(a.target) - cards.indexOf(b.target));
          visible.forEach((entry, index) => {
            this.observer.unobserve(entry.target);
            if (this.motion.matches) return;
            const animation = entry.target.animate([
              { opacity: 0, transform: `translateY(${mobile ? 8 : 12}px)` },
              { opacity: 1, transform: 'translateY(0)' }
            ], {
              duration: mobile ? 250 : 350,
              delay: mobile ? 0 : Math.min(index * 50, 200),
              easing: 'cubic-bezier(.22, 1, .36, 1)',
              fill: 'backwards'
            });
            this.animations.add(animation);
            animation.onfinish = () => this.animations.delete(animation);
          });
        }, { threshold: 0.01 });
        cards.forEach(card => {
          const box = card.getBoundingClientRect();
          if (box.top >= innerHeight || box.left >= innerWidth || box.right <= 0) {
            this.observer.observe(card);
          }
        });
        this.onMotionChange = () => {
          if (!this.motion.matches) return;
          this.observer.disconnect();
          this.animations.forEach(animation => animation.cancel());
          this.animations.clear();
        };
        this.motion.addEventListener('change', this.onMotionChange);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.animations?.forEach(animation => animation.cancel());
        if (this.onMotionChange) this.motion.removeEventListener('change', this.onMotionChange);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
